const DROPDOWN_VALUE_MAX_LENGTH = 24;

/**
 * Truncate the value of a dropdown option. This is used in scenarios where
 * we have either the name, value, or default to a generic value.
 * @param option
 * @param index
 */
export function formatVariantSelectValue(option: any, index: number) {
  const value = option.name || String(option.value) || `Variant ${index + 1}`;
  if (value.length > DROPDOWN_VALUE_MAX_LENGTH - 3) {
    return `${value.slice(0, DROPDOWN_VALUE_MAX_LENGTH)}...`;
  }
  return value;
}

export function truncateStr(
  value: string | undefined,
  maxLength = DROPDOWN_VALUE_MAX_LENGTH,
) {
  if (!value) {
    return '';
  }
  if (value.length > maxLength - 3) {
    return `${value.slice(0, maxLength)}...`;
  }
  return value;
}
